import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function Naver(){
    const { pathname } = useLocation();

    useEffect(() => {
        if (!window.wcs_add) window.wcs_add = {};
        window.wcs_add["wa"] = "s_257328b751ec";

        let retry = 0;
        const timer = setInterval(() => {
            if (window.wcs) {
                clearInterval(timer);
                window.wcs.inflow("amanorent.co.kr");
                window.wcs_do();
            } else if (++retry > 50) {
                clearInterval(timer);
            }
        }, 100);

        return () => clearInterval(timer);
    }, [pathname]);

    return null;
}